import {BaseForm} from '@management-ui/core';
import * as React from 'react';
import {forwardRef, useCallback, useContext, useImperativeHandle, useRef} from 'react';
import {ServiceContext} from '../../../../components/Services';
import Fields from './Fields';

const SendToInstallerForm = forwardRef(({contact, job, onSent}, ref) => {
  const services = useContext(ServiceContext);
  /** @type {({current: BaseForm})} */
  const formRef = useRef(null);

  useImperativeHandle(ref, () => ({
    save() {
      formRef.current.save();
    }
  }));

  return (
    <BaseForm
      ref={formRef}
      entity={contact}
      type="contact"
      fieldsComponent={(props) => <Fields {...props} job={job}/>}
      onSave={useCallback(({contact}) => (
        services.job.notifyInstaller(job, contact)
      ), [services, job])}
      onSaved={onSent}
    />
  );
});

export default SendToInstallerForm;
